import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center h-screen" }
const _hoisted_2 = {
  ref: "builder",
  id: "email-builder-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UISpin = _resolveComponent("UISpin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_UISpin, { class: "text-primary" })
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.loading]
    ])
  ]))
}